import { useApiGet } from '../../../shared/api/utils/reactQueryProvider';
import { getRiderAssistantDetails } from '../../api/services/RiderAssistant';
import { IRiderAssistantDetails } from '../../types/riderAssistant';

interface IUseRiderAssistantDetailsQuery {
  riderAssistantId: string;
}

export const useRiderAssistantDetailsQuery = ({ riderAssistantId }: IUseRiderAssistantDetailsQuery) => {
  return useApiGet<{ data: IRiderAssistantDetails }>(
    ['removedRiderAssistantDetails'],
    () => getRiderAssistantDetails(riderAssistantId),
    {
      enabled: true,
    }
  );
};
